/** GraphQL Mutation that sets a shipping address on received cart. */
export default `
  mutation setAddressesOnCart($input: SetAddressesOnCart) {
    setAddressesOnCart(
      input: $input
    )
  }
`;
